export default __webpack_public_path__ + "static/media/169.0ef07662.png";